import { EventPage } from '@/imports/ui/pages/events/EventPage';

export default EventPage;
